export default __webpack_public_path__ + "task-list-desktop.43851776.svg";